module.exports = __webpack_public_path__ + "static/media/DBY.4f626928.png";